import { render, staticRenderFns } from "./InstructionList.vue?vue&type=template&id=004f6f08&scoped=true&"
import script from "./InstructionList.vue?vue&type=script&lang=js&"
export * from "./InstructionList.vue?vue&type=script&lang=js&"
import style0 from "./InstructionList.vue?vue&type=style&index=0&id=004f6f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f6f08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
